import { ParsersPanel } from "../../../api/ParsersPanel";
import { useSourceStats } from "./useSourceStats";

export function useTamrurSources(days = 7, threshold?: number) {
  return useSourceStats(ParsersPanel.getTamrurSources, days, threshold);
}
